import React, { FC, useState } from "react";
import { Box, Typography } from "@mui/material";
import { containerStyle, fontStyles } from "./sortByStyles";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { datePickerContainerStyle } from "./dateRangeStyles";
import moment from "moment";
import useIsMobile from "../mobileVersion/useIsMobile";

type DateRangeProps = {
  fromDate?: Date;
  toDate?: Date;
  setFromDate?: (date: Date | undefined) => void;
  setToDate?: (date: Date | undefined) => void;
};

const DateRange: FC<DateRangeProps> = ({
  fromDate,
  toDate,
  setFromDate,
  setToDate,
}) => {
  const [open, setOpen] = useState(false);
  const textStyle = { ...fontStyles, color: "#000" };
  const [isToDate, setIsToDate] = useState(false);
  const isMobile = useIsMobile();

  const showDatePicker = () => {
    setOpen(!open);
    setIsToDate(false);
    setFromDate && setFromDate(undefined);
    setToDate && setToDate(undefined);
  };

  const selectDate = (date: Date) => {
    if (isToDate) {
      setToDate && setToDate(date);
      setIsToDate(false);
      setOpen(false);
    } else {
      setFromDate && setFromDate(date);
      setIsToDate(true);
    }
  };

  return (
    <Box display={"flex"} flexDirection={"column"}>
      <Box
        sx={{
          ...containerStyle,
          width: isMobile ? "auto" : "140px",
          padding: { xs: "10px", sm: "10px 16px" },
        }}
        onClick={showDatePicker}
      >
        {fromDate || toDate ? (
          <>
            <Typography sx={textStyle}>
              {fromDate ? moment(fromDate).format("DD/MM/YYYY") : ""}
            </Typography>
            <Typography sx={textStyle}>-</Typography>
            <Typography sx={textStyle}>
              {toDate ? moment(toDate).format("DD/MM/YYYY") : ""}
            </Typography>
          </>
        ) : (
          <>
            <Typography sx={fontStyles}>Select date</Typography>
            <CalendarMonthOutlinedIcon
              sx={{
                color: "#333333",
                width: "17px",
                height: "18px",
                paddingLeft: isMobile ? "12px" : "0px",
              }}
            />
          </>
        )}
      </Box>
      {open && (
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DateCalendar
            sx={datePickerContainerStyle}
            minDate={isToDate ? moment(fromDate) : undefined}
            onChange={(date) => selectDate(date ? date.toDate() : null)}
            disableFuture
            disableHighlightToday
          />
        </LocalizationProvider>
      )}
    </Box>
  );
};

export default DateRange;
